import { authorizedUser } from "components/CommonComponents/CommonFunctions";
import * as api from "../API/index";
import { trainingCenterList, states, cities } from "constants/trainingCenter";

//get training center list
export const getTrainingCenterList = async (
  dispatch,
  pageNum,
  filterParams,
  searchString,
) => {
  try {
    const res = await api.training_center_list(
      pageNum,
      filterParams,
      searchString,
    );
    dispatch({ type: trainingCenterList, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: trainingCenterList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

//get training center by ID
export const getTrainingCenterByID = async (id) => {
  try {
    const res = await api.get_training_center_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//add training center
export const addTrainingCenter = async (bodyData) => {
  try {
    const res = await api.add_training_center(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

//edit training center by ID
export const editTrainingCenter = async (id, bodyData) => {
  try {
    const res = await api.edit_training_center(id, bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getStates = async (dispatch) => {
  try {
    const res = await api.state_list();
    dispatch({ type: states, payload: res.data });
  } catch (error) {
    dispatch({ type: states, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

export const getCities = async (dispatch, filtersJSON) => {
  try {
    const res = await api.city_list(filtersJSON);
    dispatch({ type: cities, payload: res.data });
  } catch (error) {
    dispatch({ type: cities, payload: error?.response?.data || error });
    authorizedUser(error?.response?.data);
  }
};